import React from 'react'

import BarChart from '../../../components/Charts/BarChart'

import * as CHART_UTILS from '../../../components/Charts/BarChart.constant'

const Rejection = ({ isLoading, groupedData }) => {
  const chartTitle = 'Hourly part produced'

  const chartLabels = []
  const data = []

  if (groupedData) {
    for (const [hour, hourlData] of Object.entries(groupedData)) {
      let totalQuantity = 0

      if (!Array.isArray(hourlData)) {
        chartLabels.push(hour)
        data.push(totalQuantity)
        continue
      }

      hourlData.forEach((data) => {
        totalQuantity += data.rejectionCount
      })

      chartLabels.push(hour)
      data.push(totalQuantity)
    }
  }

  const dataGroup = [
    {
      ...CHART_UTILS.BAR,
      label: 'Rejection',
      data: data,
      backgroundColor: '#7afade',
      borderColor: '#04b890'
    }
  ]

  if (isLoading) {
    return <div>Loading....</div>
  }

  return (
    <div
      style={{
        padding: '16px 0'
      }}
    >
      <BarChart
        chartTitle={chartTitle}
        chartLabels={chartLabels}
        dataGroup={dataGroup}
        xLabel="Hours"
        yLabel="Rejection quantity"
        minValue={0}
        maxValue={100}
        stepValue={5}
        height="30%"
      />
    </div>
  )
}

export default Rejection
